var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOfDuctyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6875 0 0 2.6875 0 6C0 9.3125 2.6875 12 6 12H14C17.3125 12 20 9.3125 20 6C20 2.6875 17.3125 0 14 0H6ZM15.5 3.25C15.8315 3.25 16.1495 3.3817 16.3839 3.61612C16.6183 3.85054 16.75 4.16848 16.75 4.5C16.75 4.83152 16.6183 5.14946 16.3839 5.38388C16.1495 5.6183 15.8315 5.75 15.5 5.75C15.1685 5.75 14.8505 5.6183 14.6161 5.38388C14.3817 5.14946 14.25 4.83152 14.25 4.5C14.25 4.16848 14.3817 3.85054 14.6161 3.61612C14.8505 3.3817 15.1685 3.25 15.5 3.25ZM12.25 7.5C12.25 7.16848 12.3817 6.85054 12.6161 6.61612C12.8505 6.3817 13.1685 6.25 13.5 6.25C13.8315 6.25 14.1495 6.3817 14.3839 6.61612C14.6183 6.85054 14.75 7.16848 14.75 7.5C14.75 7.83152 14.6183 8.14946 14.3839 8.38388C14.1495 8.6183 13.8315 8.75 13.5 8.75C13.1685 8.75 12.8505 8.6183 12.6161 8.38388C12.3817 8.14946 12.25 7.83152 12.25 7.5ZM5.25 4.25C5.25 3.83437 5.58437 3.5 6 3.5C6.41563 3.5 6.75 3.83437 6.75 4.25V5.25H7.75C8.16562 5.25 8.5 5.58437 8.5 6C8.5 6.41563 8.16562 6.75 7.75 6.75H6.75V7.75C6.75 8.16562 6.41563 8.5 6 8.5C5.58437 8.5 5.25 8.16562 5.25 7.75V6.75H4.25C3.83437 6.75 3.5 6.41563 3.5 6C3.5 5.58437 3.83437 5.25 4.25 5.25H5.25V4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOfDuctyIcon);
export default __webpack_public_path__ + "static/media/call-of-ducty-icon.8a722e827e1cd1d5ea16ec6b26142aea.svg";
export { ForwardRef as ReactComponent };